import {
  PURCHASEDETAIL_LOADING,
  GET_PURCHASEDETAIL,
  GET_PURCHASEDETAIL_SUCCESS,
  GET_PURCHASEDETAIL_FAIL,
  ADD_PURCHASEDETAIL_SUCCESS,
  ADD_PURCHASEDETAIL_FAIL,
  DELETE_PURCHASEDETAIL_SUCCESS,
  DELETE_PURCHASEDETAIL_FAIL,
  UPDATE_PURCHASEDETAIL_SUCCESS,
  UPDATE_PURCHASEDETAIL_FAIL,
  PURCHASEDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  purchaseDetails: [],
  error: {},
};

const PurchaseDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PURCHASEDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PURCHASEDETAIL:
          return {
            ...state,
            purchaseDetails: action.payload.data,
            isPurchaseDetailCreated: false,
            isPurchaseDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PURCHASEDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_PURCHASEDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isPurchaseDetailCreated: false,
            isPurchaseDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PURCHASEDETAIL: {
      return {
        ...state,
        isPurchaseDetailCreated: false,
        loading: true,
      };
    }

    case PURCHASEDETAIL_LOADING: {
      return {
        ...state,
        isPurchaseDetailCreated: false,
        loading: true,
      };
    }

    case ADD_PURCHASEDETAIL_SUCCESS:
      return {
        ...state,
        isPurchaseDetailCreated: true,
        loading: false,
        purchaseDetails: [action.payload.data, ...state.purchaseDetails],
      };

    case ADD_PURCHASEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PURCHASEDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPurchaseDetailCreated: true,
        purchaseDetails: state.purchaseDetails.filter(
          purchaseDetail => purchaseDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PURCHASEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PURCHASEDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isPurchaseDetailCreated: true,
        purchaseDetails: state.purchaseDetails.map(purchaseDetail =>
          purchaseDetail.id.toString() === action.payload.data.id.toString() ? { ...purchaseDetail, ...action.payload.data } : purchaseDetail
        ),
      };

    case UPDATE_PURCHASEDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PURCHASEDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default PurchaseDetail;